import { Component, OnInit, Input, Output } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [HttpClientModule, HttpClient]
})

export class AppComponent implements OnInit {

  constructor(private httpClient: HttpClient){
  }

@Output() questions = [];
@Output() answers = [
]
@Input() submittedAnswer = "";

  answer = "";
  correctAnswer="";
  displayQuestion = "";
  progressBarPercentage = 1;
  progressBarColor="#488aff";
  counter=1;
  userPoints=0;
  questionPoints=100;

ngOnInit() {
  this.getQuestions();
  this.andAction();
  }

andAction(){
  let timer = setInterval(() => {
    this.progressBarPercentage+=1;
    if(this.progressBarPercentage == 100){
        clearInterval(timer);
        if(this.submittedAnswer==this.correctAnswer){
          this.answer="Good job! " + this.correctAnswer + " is the correct answer!";
          this.userPoints = this.userPoints + this.questionPoints;
        }
        else
        {
          this.answer="Sorry, " + this.correctAnswer + " is the correct answer!"
        }
    }
}, 100);
}

onSubmitAnswer(answerData: {finalAnswer: string}) {
  this.submittedAnswer = answerData.finalAnswer;
  if(this.progressBarPercentage > 50 && this.progressBarPercentage < 75){
    this.questionPoints = 75;
  }
  if(this.progressBarPercentage > 75 && this.progressBarPercentage < 100){
    this.questionPoints = 25;
  }
}

getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

nextQuestion(){
  this.correctAnswer="";
  this.displayQuestion = "";
  this.counter=1;
  this.userPoints=0;
  this.getQuestions();
  this.andAction();
}

getQuestions(){
  this.questions.length = 0;
  this.answer = "";
  this.answers.length = 0;
  this.progressBarPercentage = 1;
      this.httpClient
      .get('https://opentdb.com/api.php?amount=10&type=multiple')
      .pipe(
        map(responseData => {
        
        //Just the first item is needed. More items returned might be duplicates.
        let firstItemReturned = false;
        for (const question in responseData ) {
          if (responseData.hasOwnProperty(question))
          {
            if (!firstItemReturned)
            {
              this.questions.push({ ...responseData });
              firstItemReturned = true;
            }
            
          }
        }
    
      return this.questions;
      })
    )
      .subscribe(data => {

        let incorrectAnswers = data[0].results[0]["incorrect_answers"];
        this.correctAnswer = data[0].results[0]["correct_answer"];
        
        this.displayQuestion = data[0].results[0]["question"];
        this.displayQuestion = this.displayQuestion.replace(/&quot;/g,'"');
        this.displayQuestion = this.displayQuestion.replace(/&#039;/g,'\'');
        
        let randomInt = (this.getRandomInt(1, incorrectAnswers.length+1));
        incorrectAnswers.splice(randomInt, 0, this.correctAnswer );  

        incorrectAnswers.forEach(answerItem => {
          this.answers.push({ answerLetter: String.fromCharCode((this.answers.length+1)+64), answerText: answerItem });
        });
     
        this.questions = data;
       });
          
    }
 
}

